<div class="pt-8 pb-16 px-2 md:py-[30px] md:px-[50px]">
  <div class="v4-layout-form">
    <div class="v4-layout-form-title">
      {{
        "connect_html_set_pricing_ratio_for"
          | translate
            : {
                name: "word.channel_" + thirdpartyType | translate
              }
      }}
      <!-- Set the pricing ratio for -->
    </div>
    <div class="v4-layout-form-desc">
      {{ "setting-custom_options-channel_price_ratio_html_渠道差价描述" | translate }}
      <!-- When using Quick Modify or smart pricing tool, the final rate for each channel will be calculated according to
      this ratio. Hostex considers baseline price as the price of the property. -->
    </div>

    @if (pageLoading) {
      <nz-skeleton [nzActive]="true" [nzParagraph]="{ rows: 8 }"></nz-skeleton>
    } @else {
      <div>
        <div class="v4-layout-field">
          <div class="v4-layout-field-label w-[120px] flex flex-row items-center">
            <img src="/assets/v4/icon-house-color.svg" class="w-[18px] mr-[8px]" alt="" />
            <span class="font-semibold">
              {{ "setting-custom_options-channel_price_ratio_html_baseline" | translate }}
            </span>
          </div>
          <div class="v4-layout-field-control text-right">
            <nz-input-group nzSuffix="%" nzSize="large" class="w-[100px]">
              <input type="number" nz-input [ngModel]="100" [disabled]="true" />
            </nz-input-group>
          </div>
        </div>

        @for (channel of listOfChannel; track $index) {
          <div class="v4-layout-field">
            <div class="v4-layout-field-label w-[120px]">
              {{ "word.channel_" + channel.thirdparty_type | translate }}
            </div>
            <div class="v4-layout-field-control text-right">
              <nz-input-group nzSuffix="%" nzSize="large" class="w-[100px]">
                <input type="number" nz-input [(ngModel)]="channel.ratio" />
              </nz-input-group>
            </div>
          </div>
        }
      </div>
      <div [class]="footerClass">
        <button
          [class]="footerConfirmBtnClass"
          nz-button
          nzType="primary"
          nzSize="large"
          [nzLoading]="loading"
          (click)="onSave()">
          {{ "word.save" | translate }}
          <!-- Go to the Booking Site -->
        </button>
      </div>
    }
  </div>
</div>
